import solutions from '@wordle/game-engine/dictionary/fr-5-solutions.json';

export const WORDLE_VERSION = 'v2';

function hashString(str: string): number {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function mulberry32(seed: number) {
  return function () {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function getDailyWordFromSolutions(
  solutionsList: string[],
  date = new Date()
): string {
  // Supprime les doublons potentiels tout en conservant l'ordre
  const uniqueSolutions = Array.from(new Set(solutionsList));

  if (uniqueSolutions.length === 0) {
    throw new Error('No daily word found');
  }

  // Mélange déterministe pour éviter l'ordre alphabétique
  const seed = hashString(WORDLE_VERSION);
  const random = mulberry32(seed);
  const shuffledSolutions = [...uniqueSolutions];
  for (let i = shuffledSolutions.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    const temp = shuffledSolutions[i]!;
    shuffledSolutions[i] = shuffledSolutions[j]!;
    shuffledSolutions[j] = temp;
  }

  // Indice de jour basé sur la date locale (à minuit), stable et déterministe
  const dayNumber = Math.floor(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000
  );

  const index = dayNumber % shuffledSolutions.length;
  const word = shuffledSolutions[index];

  if (!word) {
    throw new Error('No daily word found');
  }

  return word;
}

export function getDailyWord(date = new Date()): string {
  return getDailyWordFromSolutions(solutions, date);
}
